import React, { createContext, useContext, useState, useCallback } from 'react';
import pt from './pt.json';
import en from './en.json';

const TRANSLATIONS = { pt, en };

const I18nContext = createContext(null);

export function I18nProvider({ children }) {
  const [lang, setLangState] = useState(
    () => localStorage.getItem('charth_lang') || 'pt'
  );

  const setLang = useCallback((l) => {
    localStorage.setItem('charth_lang', l);
    setLangState(l);
  }, []);

  const t = useCallback((key) => {
    return TRANSLATIONS[lang]?.[key] || TRANSLATIONS['pt']?.[key] || key;
  }, [lang]);

  return (
    <I18nContext.Provider value={{ lang, setLang, t }}>
      {children}
    </I18nContext.Provider>
  );
}

export function useI18n() {
  return useContext(I18nContext);
}

export function useT() {
  const ctx = useContext(I18nContext);
  // Defensive: if a component is ever rendered outside <I18nProvider>,
  // degrade gracefully (pt fallback / raw key) instead of crashing the app.
  if (ctx && ctx.t) return ctx.t;
  return (key) => TRANSLATIONS.pt?.[key] || key;
}
